import { DatePipe } from '@angular/common';
import { CommentStmt } from '@angular/compiler';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { columnsTotalWidth } from '@swimlane/ngx-datatable';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';
import { XlsxService } from 'src/app/services/xlsx/xlsx.service';
import { ExportExcelService } from 'src/app/shared/xlsx-view/export-excel.service';

@Component({
  selector: 'app-whitelist-users',
  templateUrl: './whitelist-users.component.html',
  styleUrls: ['./whitelist-users.component.scss']
})
export class WhitelistUsersComponent implements OnInit {
  NameOfFile1: any = "choose File"
  File: any = ""
  submitted: boolean = false
  schemeID: any
  response: any
  rejectedRecordArray:any
  isExcel_upload:boolean = false
  disableUploadButton : boolean = false


  constructor(
    private modalservice: NgbModal,
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private toast: ToastClientService,
    private exportExcel: ExportExcelService,
    private activatedRoute: ActivatedRoute,
    private xlsx : XlsxService,
    private datePipe : DatePipe

  ) {

    this.activatedRoute.params.subscribe((res: any) => {
      console.log(res)
      // {data: '24'}
      this.schemeID = res.id
    })

  }

  ngOnInit() {
  }

  openModal(modal) {
    this.modalservice.open(modal, { centered: true })
  }

  selectFile(e) {
    this.File = e.target.files[0]
    this.NameOfFile1 = e.target.files[0].name
  }

  downloadExcelTemplate() {
    let header = ["mobile"]
    this.exportExcel.commonPrintHeaders(header, "whitelistUsers")
  }

  // Remaining 
  DownloadRejectedRecords(){
    this.xlsx.export(this.rejectedRecordArray,`FailedRecords_${this.datePipe.transform(new Date ())}`)
  }

  closeModal() {
    this.modalservice.dismissAll()
    this.NameOfFile1 = "Choose File"
    this.disableUploadButton = false
  }


  Upload() {
    let localStorageData = JSON.parse(localStorage.getItem("program"))
    console.log(localStorageData)
    console.log("sdjfsduyc")
    if (this.File == undefined || this.File == null) {
      this.submitted = true
      console.log("sdkhfsd")
      return
    }
    let payload = {
      "scheme_id":this.schemeID,
      "excel_data": this.File,
      "program_id": 1
    }
    console.log(payload)
    const formData = new FormData()
    formData.append("scheme_id", this.schemeID)
    formData.append("excel_data", this.File)
    formData.append("program_id", "1")
    this.apiService.upload1(this.apiConfig.schemeUserMapping, formData).subscribe((res: any) => {
      try {
        this.response = res.body.data
        this.rejectedRecordArray = res.body.data.rejected_reason
        console.log(this.response)
        this.toast.Success(res.body.data.message)
        this.File = ''
        this.isExcel_upload = true
        this.closeModal()    
      }
      catch (err) {
        this.disableUploadButton = true
        // this.toast.Error(err)
      }
    })
  }

}